'use client';

import { Button } from '@/components/ui/button';

export function ScrollButton() {
  const handleScrollToHowToParticipate = () => {
    const element = document.getElementById('how-to-participate');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Button
      onClick={handleScrollToHowToParticipate}
      className="bg-[#A9F84A] hover:bg-[#8EE328] h-[50px] w-full rounded-[10px] py-[19px] font-[440] text-[17px] text-foreground flex justify-center md:max-w-[312px]"
    >
      Подробнее
    </Button>
  );
}
